export const IS_DEBUG = process.env.NODE_ENV === 'development';
export const REACT_APP_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3100/api/v1';

export const AuthStorageItem = 'CRMAuthToken';
